const Global = {
    loginTarget: 'manual',
    isLogin: false,
    tiposDocumentoIdentidad: [],
    tiposIngreso: [],
    tiposVivienda: [],
    generos: [],
    estadoCivil: [],
    departamentos: [],
    provincias: [],
    distritos: [],
    departamentos: [],
    programs: [],
    institucionesEducativas: [],
    gradosAcademicos: [],
    paises: [],
    rubrosEmpresa: [],
    costo: 0.00,
    pacademico: '',
    idProgramaAcademicoValue: '',
    gradosAcademicosAll: [],
    oportunities: [],
    userfindsub: null,
    otherinfo: null
}

export default Global;